import { LitElement, html, css } from './-global.min.js'

export class HHAccordion extends LitElement {
  static properties = {
    button: { state: true },
    content: { state: true },
    slot: { state: true },
  }

  firstUpdated() {
    super.firstUpdated()
    this.maxHeight = this.getAttribute('max-height')
    this.initAccordion()
  }

  initAccordion() {
    this.slot = this.shadowRoot.querySelector('slot')
    for (const child of this.slot.assignedElements()) {
      if (child.tagName === 'BUTTON') {
        this.button = child
      } else {
        this.content = child
      }
    }

    this.initAccordionAction()
  }

  initAccordionAction() {
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        this.button.classList.toggle('active')
        if (this.content.style.maxHeight) {
          this.content.style.maxHeight = null
        } else {
          this.content.style.maxHeight =
            this.maxHeight ?? `${this.content.scrollHeight}px`
        }
      })
    }
  }

  static styles = css`
    .accordion-wrapper {
      display: var(--hh-display);
      flex-direction: var(--hh-flex-direction);
    }
  `

  render() {
    return html`
      <div class="accordion-wrapper">
        <slot></slot>
      </div>
    `
  }
}

customElements.define('hh-accordion', HHAccordion)
